import { useEffect, useState } from 'preact/hooks';
import { fmtAsOf } from '../../lib/dates.js';

// "Nema signala" under the top bar while the browser is offline or the screen shows the offline copy.
export function OfflineBar() {
  const [state, setState] = useState({ onLine: navigator.onLine, offline: false, asOf: null });

  useEffect(() => {
    const answer = (e) => setState({ onLine: navigator.onLine, ...e.detail });
    const on = () => setState((x) => ({ ...x, onLine: true, offline: false }));
    const off = () => setState((x) => ({ ...x, onLine: false }));
    window.addEventListener('api-answer', answer);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('api-answer', answer);
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  if (state.onLine && !state.offline) return null;
  return (
    <p class="offline-bar" role="status">
      {state.asOf ? `Nema signala — vidiš stanje od ${fmtAsOf(state.asOf)}.` : 'Nema signala.'}
    </p>
  );
}
